import { render, staticRenderFns } from "./EventRegistrationPage.vue?vue&type=template&id=12ea0a2e&"
import script from "./EventRegistrationPageVue.ts?vue&type=script&lang=ts&"
export * from "./EventRegistrationPageVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports